import React, {useEffect, useState} from 'react'
import ExamImage from "../assets/images/exam.svg";
import {toPersianNumber, formatNumbers} from "../utils/numberConversion";
import {api} from "../utils/gashtaltAPI";
import {toast} from "react-toastify";
import {useNavigate} from "react-router-dom";
import DownloadHandler from "../utils/downloadHandler";
import {useDisclosure} from "@chakra-ui/react";
import PayModal from "./PayModal";
import FilePayModal from "./FilePayModal";
import BundlePayModal from "./BundlePayModal";


function FileCard({id, name,description=null, Image, price,files,downloadable=false, hasPaid = false, onClick}) {
    const {isOpen, onOpen, onClose} = useDisclosure();
    //const {isOpen:isfile, onOpen:onfile, onClose:onfileclose} = useDisclosure();
    const [currentFile,setcurrentfile] = useState(0)
    const navigate = useNavigate();

    return (<div className="col-lg-4 col-12 d-flex flex-column align-items-center">
        <div className="panel-exam-card d-flex flex-column align-items-center px-4" onClick={onClick}>
            <h5 className={'exam-card-title'}>{name}</h5>
            <img src={Image} className="card-img-top d-block mx-auto" alt="خطا" style={{
                paddingLeft: '1rem',
                paddingBottom: '.75rem',
                width: '65%',
                marginLeft: '1rem',
                marginRight: '1rem'
            }}/>
            <div className="d-flex flex-column justify-content-end flex-fill gap-2 col-11 pt-3">
                {hasPaid && downloadable && (
                    <>
                        <div dangerouslySetInnerHTML={{__html: description ?? ""}}></div>
                        <div className={'d-flex flex-column gap-1 my-1'}>
                            {files.map((file, index) => {
                                return (<button
                                    className={'btn btn-outline-green'} onClick={() => {
                                    DownloadHandler(file.downloadUrl)
                                }}> دانلود {file.name} </button>)
                            })}
                        </div>
                    </>
                )}
                {hasPaid && !downloadable && (
                    <>
                        <p>دانلود فایل ها در حال حاضر غیرفعال است</p>
                    </>
                )}
                {!hasPaid && (
                    <div>
                        {/*<div className={'d-flex flex-column gap-1 my-1'}>
                            {files.map((file, index) => {
                                return (<button
                                    className={'btn btn-outline-green'} onClick={()=>{
                                        setcurrentfile(file.id)
                                        onfile()
                                }}> خرید {file.name} ({price === 0 ? 'رایگان' : `${toPersianNumber(formatNumbers(file.price))} تومان`})</button>)
                            })}</div>*/}
                        <button className="btn btn-outline-green col-12" onClick={onOpen}>
                            خرید فایل ها
                            (
                            {price === 0 ? 'رایگان' : `${toPersianNumber(formatNumbers(price))} تومان`}
                            )
                        </button>
                    </div>
                )}
                {/*<FilePayModal onClose={onfileclose} isOpen={isfile} productId={currentFile}/>*/}
                <BundlePayModal onClose={onClose} isOpen={isOpen} productId={id}/>
            </div>
        </div>
    </div>);
}

export default FileCard;
